/**
 * 需要先注册与app交互的方法，否则不能通过 nativeApp 实例对象调用。
 * sync : 不需要返回值的
 * async : 需要返回值的
 */
export default Object.freeze({
  sync: [
    "setTitle", // 设置标题
    "backToHome", // 返回首页
    "finish", // 关闭webview
    "toWinCart", // 跳转购物车
    "setStatusBarTextWhite",
    "setStatusBarTextBlack",
    "toOrderList",
    "refreshCart", // 刷新购物车列表
    "refreshOrder", // 刷新订单列表
    "toSaleHistory",
    "signOut", // app退出
    "toLogin", // app登录
    "callPhone", // app打电话
    "setWebViewHeight", // 首页设置webview高度
    "setWebViewHeightFinally", // 首页设置webview高度--最终设置
    "callAlipay", // 支付宝支付
    "callWXPay", // 微信支付
    "callUnionPay", // 云闪付支付
    "callAlbum",
    "updateOrderListTab", // 通知app订单状态
    "toWinOrderCorfirm",
    "callTyreOrderDetailWithHead", // 有头的webview
    "callFullScreenTyreOrderDetail", // 无头的webview
    "callWeb", // 打开webview (String url, boolean hasTitle, boolean hasStatusBar)
    "setWebStausBarColor", // 设置状态栏颜色 （String barBgColor, boolean isBlackBarTextColor）
    "setWebStausBarAlpha", // 设置状态栏透明度 （float alpha）
    "warehouseInDetail", // 入库详情
    "warehouseOutDetail", // 出库详情
    "warehouseBatchOutDetail", // 批量出库详情
    "callCustomCamera", // 安卓特有方法 参数：1拍照 2视频
    "canGoBack" // app webview 是否可以返回，1可以 0不可以
  ],
  async: [
    "setToken", // 获取app的token
    "getStatusBarHeight", // 获取状态栏高度
    "getBottomHeight", // 获取手机底部高度
    "callScanCoupon", //调扫码
    "isHasAlipay", // app 是否安装支付宝
    "isHasWechat", // app 是否安装微信
    "getLongitudeLatitude", // app 获取经纬度，英文逗号分隔开
    "callUniOutBound", // 打开联保出库
    // "getVersionCode", // 获取app的版本号
    "openWarrantyCardAppealPage" // 打开联保卡冒领申诉页面
  ]
});
